export const BETSLIP_EVENT_ERRORS = [520, 521, 522, 523];
